import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { ContentApi, type GetContactResponse } from '@shared/api';

interface ContactType {
  data: GetContactResponse | null;
  loading: boolean;
  error: string | null;
  getContact: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useContactStore = create<ContactType>((set) => ({
  data: null,
  loading: false,
  error: null,

  getContact: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null, data: null });
      const result = await ContentApi.getContact(signal);
      set({ data: result ?? null, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: null, loading: false, error: null }),
}));
